<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Nombre</th>
                <th :class="StyleTh">Tipo</th>
                <th :class="StyleTh">Orden de Compra</th>
                <th :class="StyleTh">N° de Lote</th>
                <th :class="StyleTh">Cantidad</th>
                <th :class="StyleTh">Fecha de Movimiento</th>
                <th :class="StyleTh">Tipo de Movimiento</th>
                <th :class="StyleTh">Usuario</th>
            </template>
            <template slot="body">
                <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><h6 :class="StylePr">{{lista.material!=null ? lista.material.Nombre : lista.herramienta!=null ? lista.herramienta.Nombre : lista.insumo.Nombre}}</h6></td>
                    <td><p :class="StyleTd">{{ lista.material!=null ? 'Material' :  lista.herramienta!=null ? 'Herramienta' : 'Insumo'}}</p></td>
                    <td><p :class="StyleTd">{{lista.orden_compra==null ? '' : lista.orden_compra.Folio}}</p></td>
                    <td><p :class="StyleTd">{{lista.NLote}}</p></td>
                    <td><p :class="StyleTd">{{lista.Cantidad}}</p></td>
                    <!-- <td><p :class="StyleTd">{{$getCleanDate(lista.created_at,false)}}</p></td> -->
                    <td><p :class="StyleTd">{{FormatoFecha(lista.created_at)}}</p></td>
                    <td><p :class="StyleTd">{{lista.TipoMovimiento}}</p></td>
                    <td><p :class="StyleTd">{{lista.usuario.NombreCompleto}}</p></td>
                </tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="8"></CSinRegistros>
            </template>
        </CList>
    </div>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionMovimiento';
export default {
    name: 'ListaMovimiento',
    props: ['sFiltros','pOrigen'],
    components: {
        // Form
    },
    data() {
        return {
            ConfigList:{
                Title: 'Movimientos',
                IsModal: false,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Almacen',
                GoRoute:'EntradaForm'
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
        async Lista(){
            this.ConfigList.ShowLoader=true;
            await this.$http.get("movimientos",{
                params:{
                    TxtBusqueda:this.Filtro.Nombre,
                    Pag:this.Filtro.Pagina,
                    Entrada:this.Filtro.Entrada
                }
            }).then((res)=>{
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows=res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader=false;
            })
        },
        Eliminar(Id){

        },
        Regresar(){
            this.$router.push({name:'panelSubMenus'});
        },
        FormatoFecha(Fecha){
            var FechaF=new Date(Fecha);
            FechaF=FechaF.toLocaleDateString("es-MX",{hour12:true,day:'numeric',month:'long',year:'numeric',hour:'numeric',minute:'numeric'});
            return FechaF;
        }
    },
    created() {
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted() {
        this.Lista();
        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
}
</script>

<style>

</style>